<template>
  <!-- Table skeleton -->
  <a-table
    :columns="generatedColumns"
    :data-source="skeletonData"
    :pagination="false"
    :size="size"
  >
    <!-- Skeleton en las CABECERAS -->
    <template #headerCell="{ column }">
      <div
        class="tree-skeleton__bar header"
      ></div>
    </template>

    <!-- Skeleton en las CELDAS -->
    <template #bodyCell="{ column }">
      <div
        class="tree-skeleton__bar cell"
      ></div>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  rows: { type: Number, default: 3 },
  cols: { type: Number, default: 7 },
  size: { type: String, default: 'middle' }
})

// Generar columnas vacías
const generatedColumns = computed(() => {
  return Array.from({ length: props.cols }).map((_, i) => ({
    title: '',
    dataIndex: `col_${i}`,
    key: `col_${i}`
  }))
})

// Filas fake
const skeletonData = computed(() =>
  Array.from({ length: props.rows }).map((_, i) => ({ key: i }))
)
</script>

<style scoped lang="sass">
.tree-skeleton
  display: flex
  flex-direction: column
  gap: 12px
  margin-top: 10px
  &__bar
    height: 10px
    border-radius: 5px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)
    background-size: 400% 100%
    animation: skeleton-loading 1.4s ease infinite
    margin: 2px 0
    &.header
      width: 60%
    &.cell
      width: 80%
      
@keyframes skeleton-loading
  0%
    background-position: 100% 50%
  100%
    background-position: 0 50%
</style>
